export default {
  computed: {
    membersRoutes() {
      return {
        "members-area-kajabi": {
          title: "Kajabi"
        },

        "members-area-memberkit": {
          title: "Memberkit"
        },

        "members-area-cademi": {
          title: "Cademi"
        },

        "members-area-astron": {
          title: "Astron Members"
        },

        "members-area-ead": {
          title: "Ead plataforma"
        },
        "members-area-alpaclass": {
          title: "Alpaclass"
        }
      };
    }
  }
}